import { render, staticRenderFns } from "./MitEmailPage.vue?vue&type=template&id=42543431&scoped=true"
import script from "./MitEmailPage.vue?vue&type=script&lang=js"
export * from "./MitEmailPage.vue?vue&type=script&lang=js"
import style0 from "./MitEmailPage.vue?vue&type=style&index=0&id=42543431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42543431",
  null
  
)

export default component.exports